import AnimatedSection from './AnimatedSection';
import { getData } from '../utils/html'

export default class extends AnimatedSection {
    constructor(m) {
        super(m);

        this.$item = this.$('item')
    }

    initTl() {
        this.scrollTl = new TimelineMax({})

        for(let item of Array.from(this.$item)) {
            let from = getData(this.getData('from', item))
            let to = getData(this.getData('to', item))

            this.scrollTl.fromTo(item, 1, from, Object.assign(to, { ease: Linear.easeNone }), 0)
        }

        this.scrollTl.pause()
    }
}
